import { useState } from 'react';
import FacilitiesComponent from '@/components/Facilities';

const FacilitiesTab = ({ organizationId }) => {
  const [errorMessage, setErrorMessage] = useState('');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        paddingTop: '20px',
      }}>
      {errorMessage && <p style={{ color: '#ff0000' }}>{errorMessage}</p>}
      <FacilitiesComponent
        setErrorMessage={setErrorMessage}
        organizationId={organizationId}
      />
    </div>
  );
};

export default FacilitiesTab;
